@if (config(); as config) {
  <div class="group">
    @for (digit of config.next.asString; track $index) {
      <div class="segment">
        <div class="display">
          <div class="display-top">{{ digit }}</div>
          <div class="display-bottom">{{ config.prev.asString[$index] }}</div>
          <div class="overlay">
            <div #overlayTop class="overlay-top">{{ digit }}</div>
            <div #overlayBottom class="overlay-bottom">{{ digit }}</div>
          </div>
        </div>
      </div>
    }
  </div>
  @if (config.label) {
    <div class="label">{{ config.label }}</div>
  }
}
